/**
 * Sticky top header — brand + logged-in user controls.
 *
 * Modo moderno únicamente (sin theme switcher).
 */
import { Leaf, LogOut, User } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { useNavigate } from 'react-router-dom'

const ROLE_LABEL = {
  superadmin: 'Super Admin',
  sales: 'Vendedor',
  user: 'Usuario',
  restricted: 'Usuario',
}

export function Header() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const onLogout = () => {
    logout()
    navigate('/login', { replace: true })
  }

  return (
    <header className="bg-expo-dark text-white shadow-lg sticky top-0 z-50">
      <div className="mx-auto px-8 py-5">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-expo-yellow p-3 rounded-xl">
              <Leaf size={40} className="text-expo-dark" />
            </div>
            <div>
              <h1 className="text-3xl font-bold tracking-tight">EXPOGREENS</h1>
              <p className="text-white/80 text-base mt-1">
                Sistema de Gestión de Exportación de Follajes
              </p>
            </div>
          </div>

          {user ? (
            <div className="flex items-center gap-5">
              <div className="flex items-center gap-3 text-white/90">
                <User size={24} />
                <div className="text-right">
                  <span className="text-base block font-medium">
                    {user.name || user.username}
                  </span>
                  <span className="text-sm text-white/70">
                    {ROLE_LABEL[user.role] || user.role}
                  </span>
                </div>
              </div>
              <button
                onClick={onLogout}
                className="flex items-center gap-2 px-7 py-3.5 text-base rounded-xl bg-expo-yellow text-expo-dark hover:bg-expo-yellow/90 transition-all font-semibold shadow-lg hover:shadow-xl"
              >
                <LogOut size={22} />
                <span>Cerrar Sesión</span>
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  )
}
